import { autoUpdate, offset, useFloating } from '@floating-ui/react';
import type { Editor} from '@tiptap/react';
import { isNodeSelection, posToDOMRect } from '@tiptap/react';

export const useEditorPopover = (editor: Editor) => {
  const { refs, floatingStyles } = useFloating({
    whileElementsMounted: autoUpdate,
    placement: 'bottom-start',
    middleware: [offset({ crossAxis: -40 })],
    elements: {
      reference: {
        getBoundingClientRect() {
          const { ranges } = editor.state.selection;
          const from = Math.min(...ranges.map((range) => range.$from.pos));
          const to = Math.max(...ranges.map((range) => range.$to.pos));

          if (isNodeSelection(editor.state.selection)) {
            let node = editor.view.nodeDOM(from) as HTMLElement;

            const nodeViewWrapper = node?.dataset?.nodeViewWrapper
              ? node
              : node.querySelector('[data-node-view-wrapper]');
            if (!nodeViewWrapper) return;

            if (nodeViewWrapper) {
              node = nodeViewWrapper.firstChild as HTMLElement;
            }

            if (node) {
              return node.getBoundingClientRect();
            }
          }
          return posToDOMRect(editor.view, from, to);
        },
      } as Element,
    },
  });

  return { refs, floatingStyles };
};
